"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function DialogSimpleHeader(props) {
    return React.createElement("div", { className: 'dialog-header l-box-h-2x' }, React.isValidElement(props.text)
        ? props.text
        : React.createElement("h2", null, props.text));
}
exports.DialogSimpleHeader = DialogSimpleHeader;
